import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Typography from '../../../components/common/Typography';

import previousAiLoadingImg from '../../../asset/img/previous_ai_loading_img.gif';

const ImageBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #f5f5f5;
  border-radius: 16px;
`;

const AiLoadingStep = () => {
  const { t } = useTranslation('previousEmployment');

  return (
    <div className="displayFlexColumn" style={{ gap: '24px' }}>
      {/* 제목 */}
      {/* 소득공제마법사 AI가\n열심히 검증하고 있어요! */}
      <Typography variant="subtitleBold" style={{ whiteSpace: 'pre-line' }}>
        {t('aiLoadingSection.title')}
      </Typography>

      {/* AI 로딩 이미지 */}
      <ImageBox>
        <img
          src={previousAiLoadingImg}
          alt="AI Loading"
          style={{ width: '250px', height: '250px' }}
        />
      </ImageBox>
    </div>
  );
};

export default AiLoadingStep;
